import { useState } from 'react';
import {
  getYouTubeVideoIframeURLFromId,
  getYouTubeVideoThumbnailFromId,
} from '@dist-marketplace-frontend/utils';

import * as Styled from './YouTubePlayer.styled';
import type { YouTubePlayerProps } from './YouTubePlayer.typed';
import Spinner from '../Spinner/Spinner';
import Box from '../Box/Box';

/**
 * Created by jay on 13/03/2023
 **/
const YouTubePlayer = (props: YouTubePlayerProps) => {
  const { id, title = 'YouTube video player' } = props;

  const [isLoaded, setIsLoaded] = useState(false);

  const thumbnail = id ? getYouTubeVideoThumbnailFromId(id) : '';
  const iframeURL = id ? getYouTubeVideoIframeURLFromId(id) : '';

  return (
    <Styled.YouTubePlayer>
      <Styled.Preview src={thumbnail} />
      {!isLoaded && (
        <Box position="absolute" top="50%" left="50%" center={true}>
          <Spinner />
        </Box>
      )}
      <Styled.Video
        isLoaded={isLoaded}
        src={iframeURL}
        frameBorder="0"
        allowFullScreen={true}
        title={title}
        onLoad={() => setIsLoaded(true)}
      />
    </Styled.YouTubePlayer>
  );
};

export default YouTubePlayer;
